module.exports = __webpack_public_path__ + "img/thumb-cranberry-havermoutmuffins.4c34c7b5.jpeg";